angular.module('iqxCore')
.service('FormSvc', function (ApiSvc, $q, $timeout, $window, $location, ApplicationSvc, QuestionnaireSvc, SweetAlert, toastSvc) {
  var svc=this

  svc.setOptions=function (scope,options) {
    scope.FormSvcOptions=angular.extend({
      fetchAPI:'',
      fetchTarget:'',
      saveAPI:'',
      savePrefix:'',
      saveWithPersonID:false,
      fetchWithPersonID:false,
      dateFields:[],
      timeFields:[],
      numberFields:[],
      booleanFields:[],
      momentFields:[],
      primaryKey:'',
      multiRow:false,
      sliceSize:0, // No paging
      primaryFetch:true,
      notLoggedIn:false,
      autoEdit:false,
      doNotPreventNav:false,
      saveCleanFields:false,
      questionnaire:null,
      lazyPage:null
    },options)

    // Old style db paging setup - new paging mechanism will act as a wrapper for this
    scope.currentPage=1
    scope.totalItems=1000000 // May be adjusted downwards when we know how many there are
    scope.itemsPerPage=scope.FormSvcOptions.sliceSize

    // New paging mechanism setup
    if(scope.FormSvcOptions.lazyPage === true){
      scope.lazyPage = {}
      scope.lazyPage.page = 1     // current page for display on website (not the Db page)
      scope.lazyPage.numPerPage = scope.FormSvcOptions.numPerPage || 10
      scope.lazyPage.lastPage = false
      scope.lazyPage.refreshResults = false
      scope.lazyPageAllRecords = [] // containg all the fetched records
      scope.lazyPageRecords = [] // somewhere to temporaraly store the records returned by the fetch
    }

    scope.classes={label:'col-sm-4', data:'col-sm-8'} // Bootstrap widths of form label and data
    
    // Date picker setup
    scope.dateFormat='dd/MM/yyyy'  
    scope.dateOptions={}
    scope.dateOptions.showWeeks=false
    scope.dateOptions.startingDay=1
    scope.dateIsOpen={}
    scope.dateOpen = function(event,sID,shiftLeft) {
      event.preventDefault()
      event.stopPropagation()
      scope.dateIsOpen[sID] = true
      if (shiftLeft) {
        $timeout(svc.shiftDatePopupLeft,0,true,sID,shiftLeft)
      }
    }

    scope.dateClose = function(sID) {
      scope.dateIsOpen[sID]=false
    }
      
    scope.autoEdit=scope.FormSvcOptions.autoEdit
    ApplicationSvc.preventNavIfEditing=!scope.FormSvcOptions.doNotPreventNav && !scope.FormSvcOptions.autoEdit
    
    // Attach the key functions to the scope for easy use by the form
    scope.update=function () {
      return svc.update(scope)
    }
     
    scope.reset=function () {
      return svc.reset(scope)
    }

    scope.fetch=function (options) {
      return svc.fetch(scope,options)
    }
      
    scope.exec=function (api,postObject) {
      return ApiSvc.exec(scope,api,postObject,scope.FormSvcOptions.notLoggedIn)
    }
      
    scope.save=function () {
      // Submit method on MiniForm - must be over-ridden in controller if needed
    }
      
    scope.setEditing=function (bOn) {
      svc.setEditing(scope,bOn)
    }

    scope.setSubmitted=function (bOn) {
      svc.setSubmitted(scope,bOn)
    }
      
    scope.back=function () {
      $window.history.back()
    }
      
    scope.home=function () {
      $location.url('/')
    }

     
    if (scope.FormSvcOptions.questionnaire) {
      scope.FormSvcOptions.questionnaire.notLoggedIn=scope.FormSvcOptions.notLoggedIn
      QuestionnaireSvc.setOptions(scope,scope.FormSvcOptions.questionnaire)
    }

  }

  svc.alert=function(title, contents, type){
    if(type==="success"){ // if it is a success alert message display a toast instead
      toastSvc.success(title, contents)
    }else{
      SweetAlert.swal({
        title:title,
        text:contents,
        type:type
      })
    }
    return contents // return the contents - this is used in some places for a promise rejection reason
  }
  
  svc.shiftDatePopupLeft=function(sID,px) {
    var el=document.getElementById(sID)
    if (el) {
      var sc=angular.element(el).isolateScope()
      if (sc && sc.position) {
        sc.position.left=0-px
        }
      }
    }
   
  svc.setEditing=function (scope,bOn) {
    if (bOn === undefined) {bOn=true}
    scope.isEditing=bOn
    ApplicationSvc.isEditing=bOn
    scope.$broadcast('isEditing',bOn)
    if (bOn && scope.QuestionnaireSvcOptions) {
      QuestionnaireSvc.linkFormFields(scope)
      }
    }

  svc.setSubmitted=function (scope,bOn) {
    if (bOn === undefined) {bOn=true}
    scope.isSubmitted=bOn
    scope.$broadcast('isSubmitted',bOn)
    }
    
  svc.saveableRecord=function(record,savePrefix,primaryKey,cleanRecord) {
    var changes=false
    var postvars={}
    savePrefix=savePrefix || ''
    primaryKey=primaryKey || ''
    angular.forEach(record, function (value,key) {
      if (key == 'qanswers') {
        if (value) { // Will be empty string if no changes to questionnaire
          postvars[key]=value
          changes=true
        }
      } else if (key == primaryKey || !cleanRecord || !ApiSvc.ValuesAreEqual(value,cleanRecord[key])) {
        postvars[savePrefix + key]=value
        if (key != primaryKey) {changes=true}
        }
      })
    if (changes) {return postvars}  // If nothing to save will return undefined
    }
      
  svc.update=function (scope, bSaveOnly, bNoValidate) {
    scope.formError=''

    if (!scope.isEditing) {return $q.when()}  // Returns a resolved promise so that it can be 'then'ed

    if (!scope.FormSvcOptions.saveAPI) {return $q.reject(svc.alert("Error", "No saveAPI in form service options.", "error"))}

    svc.setSubmitted(scope,true)

    if (scope.theForm.$valid || bNoValidate) {
      var changes=false
      var postvars={}

      angular.forEach(scope.theRecord, function (value,key){
        if (scope.FormSvcOptions.saveCleanFields || key == scope.FormSvcOptions.primaryKey || !ApiSvc.ValuesAreEqual(value,scope.cleanRecord[key])){
          postvars[scope.FormSvcOptions.savePrefix + key]=value
          if (key != scope.FormSvcOptions.primaryKey){changes=true}
        }
      })

      if (scope.QuestionnaireSvcOptions) {
        var qanswers=QuestionnaireSvc.answers(scope)
        if (qanswers) {
          if (!scope.QuestionnaireSvcOptions.postVar) {return $q.reject(svc.alert("Error", "No postVar in questionnaire service options", "error"))}
          postvars[scope.QuestionnaireSvcOptions.postVar]=qanswers
          changes=true
        }
      }

      if (!changes) { // if no changes then don't bother saving
        if (bSaveOnly) {return $q.when()}
        return svc.fetch(scope)
      }

      if(scope.FormSvcOptions.saveWithPersonID){
        postvars[scope.FormSvcOptions.savePrefix+'PersonID']=ApplicationSvc.currentUser.personID
      }

      return ApiSvc.exec(scope,scope.FormSvcOptions.saveAPI,postvars,scope.FormSvcOptions.notLoggedIn)
      .then(function (res) {
        if (bSaveOnly) {return $q.when(res)} // In this case only we pass out the IQXResult from the exec
        return svc.fetch(scope)
      })

    } else {

      if (scope.QuestionnaireSvcOptions) {
        QuestionnaireSvc.linkFormFields(scope)
      }
      return $q.reject(svc.alert("Error", "Please check that all required fields have been filled in and are correct.", "error"))
    }
  }
     
  svc.reset=function(scope) {
    if (scope.cleanRecord) {
      scope.theRecord=angular.copy(scope.cleanRecord)
      }
    if (scope.QuestionnaireSvcOptions) {
      QuestionnaireSvc.reset(scope)
      }
    if (scope.theForm != undefined)  {
      scope.theForm.$setPristine()
      scope.theForm.$setUntouched()
      }
    svc.setEditing(scope,false)
    svc.setSubmitted(scope,false)
    scope.formError=''
  }

  function getPage(scope, options){

    if(options.sliceSize < (scope.lazyPage.numPerPage*2) ){ // check if slice size is too small - if it is too small the new paging mechanism will now work correctly
      throw "Slice size too small - For the new paging mechanism to work options.sliceSize must be double (or more than double) options.numPerPage."
    }

    var isFirstFetch = false

    if(scope.lazyPage.refreshResults === true || scope.lazyPageAllRecords.length === 0){ // check if refresh results flag is set or lazyPageALlRecords is empty
      isFirstFetch=true
      scope.lazyPage.lastPage=false // reset last page incase it has been set to true by a prev fetch
      scope.lazyPage.page=1 // should goto page 1 on webpage if we are not already, e.g. results have been refreshed due to changes to a filter
      scope.lazyPage.refreshResults = false // we are refreshing the results so set to false so we do not refresh them again on next fetch (unless controller sets it to true again)
      scope.lazyPageAllRecords=[]
      scope.theRecords=[]
    }
    // set page of resutls to fetch - used by apiAvc
    scope.currentPage = Math.floor(scope.lazyPage.page*scope.lazyPage.numPerPage/options.sliceSize)+1

    if( isFirstFetch || (!scope.lazyPage.lastPage && ((scope.lazyPage.page+1)*scope.lazyPage.numPerPage) > scope.lazyPageAllRecords.length) ){
      scope.lazyPage.nextPageAvailable = false
      options.fetchTarget = "lazyPageRecords"

      ApiSvc.fetch(scope,options).then(function(){
        // add the new records to array holding all the records
        angular.forEach(scope.lazyPageRecords, function(value, key){
          scope.lazyPageAllRecords.push(value)
        })

        if(scope.lazyPageRecords.length<options.sliceSize){
          scope.lazyPage.lastPage = true
        }

        scope.lazyPageRecords = [] // clear lazyPageRecords as we dont need them any more

        if(isFirstFetch){ // first time fetch so put new stuff into the record
          scope.theRecords = scope.lazyPageAllRecords.slice(0, scope.lazyPage.numPerPage)
        }
      })
    }

    if(!isFirstFetch){ // if this is not the first fetch, put stuff into the record as it is already loaded
      scope.theRecords = scope.lazyPageAllRecords.slice((scope.lazyPage.page-1)*scope.lazyPage.numPerPage, scope.lazyPage.page*scope.lazyPage.numPerPage)
    }

  }

  svc.fetch=function (scope,options) {
    var theResult
    options = options || scope.FormSvcOptions

    if(options.lazyPage === true){
      getPage(scope, options)
      return
    }

    if (!options.primaryFetch) {
      return ApiSvc.fetch(scope,options)
    }
    if (scope.theForm != undefined)  {
      scope.theForm.$setPristine()
      scope.theForm.$setUntouched()
      } 
    svc.setEditing(scope,false)
    svc.setSubmitted(scope,false)
    scope.formError=''
    return ApiSvc.fetch(scope,options)
      .then(function () {
        if (scope.theRecord) {
          scope.cleanRecord=angular.copy(scope.theRecord)
          } // Note: The questionnaire service handles its own clean record storage
        })
      .then(function () {
        if (scope.QuestionnaireSvcOptions) {
          return QuestionnaireSvc.fetch(scope)
          }
        })
      .then(function () {
        if (options.autoEdit) {
          return $timeout(scope.setEditing,0,true,true)  // Wrap in timeout to ensure DOM is built and ready first
          }
        })
    }
    
  svc.unSpliceSelectList=function(sList) {
    // Fixed 1/4/16 - Value and Description were the wrong way round
    var ar=sList.split(/\]\~\[/)
    var rv=[],d,v
    while (ar.length>1) {
      v=ar.shift()
      d=ar.shift()
      rv.push({Value:v,Description:d})
      }
    return rv
    }
    
  svc.arrayTotal=function(ar,fld,filter) {
    var rv=0
    var val
    angular.forEach(ar,function(it){
      if (!angular.isFunction(filter) || filter(it)) {  // Filter function is optional
        if (angular.isFunction(fld)) {  // Can pass a function instead of a field name
          val=fld(it)
        } else {
          val=it[fld]
        }
        if (isFinite(val)) {
          rv+=parseFloat(val)
        }
        }
      })
    return rv
    }
    
  svc.arrayFoundValue=function(ar,fld,val) {
    var rv=false
    angular.forEach(ar,function(it){
      if (it[fld]==val) {rv=true}
      })
    return rv
    }
      
  svc.getFirstWord=function(str) {
    if (str.indexOf(' ') === -1)
      return str
    else
      return str.substr(0, str.indexOf(' '))
    }
    
  svc.getHtmlFromId=function(id) {
    var el=document.getElementById(id)   // The form content is defined in a hidden div with the specified id
    return angular.element(el).html()    // The div must have the ng-non-bindable directive
  }

  svc.modalForm=function(scope,id,data,size,classes,tags,onOpenCallBack,forceAction=false) {
    // if a function is passed in the below code it is executed when the modal has loaded with its content!
    onOpenCallBack = onOpenCallBack || {}
    // If a loaded questionnaire is passed in the optional tags, the resulting data object will have a qanswers field ready for posting. The view template must have a +FormQuestionnaire or iqx-questionnaire.
    var html, htmlFile
    if (id.match(/[.]html$/i)) {
      htmlFile=id   // id is view file name
    } else if (id.match(/[<][/]/)) {
      html=id   // id is literal html
    } else {
      html=svc.getHtmlFromId(id)
    }
    data=data || {}                      // Initial form data may be specified or omitted
    classes=classes || scope.classes     // E.g. {label:'col-sm-3', data:'col-sm-7'} to change the label:field proportions
    return ApplicationSvc.openDialog({
      template: html,
      templateUrl: '/views/'+htmlFile,
      size: size || 'sm',
      backdrop: (forceAction ? 'static' : true),
      keyboard: (forceAction ? false : true),
      controller:data.$form_controller || 'ModalFormCtrl',
      scope:scope,   // Specify the parent scope of the dialog's scope
      resolve: {
        getData: function() {
          return {theRecord:data, classes:classes, tags:tags}
          }
        }
      },
        onOpenCallBack
      )
    }

  svc.modalInfo=function(scope,id,data,size) {
    var html, htmlFile
    if (id.match(/[.]html$/i)) {
      htmlFile=id   // id is view file name
    } else if (id.match(/[<][/]/)) {
      html=id   // id is literal html
    } else {
      html=svc.getHtmlFromId(id)
    }
    return ApplicationSvc.openDialog({
      template: html,
      templateUrl: htmlFile,
      size: size || 'sm',
      backdrop: true,
      controller: 'ModalInfoCtrl',
      scope:scope,   // Specify the parent scope of the dialog's scope
      resolve: {
        getData: function() {
          return data
          }
        }
      })
    }

})

.controller('ModalFormCtrl', function ($scope, $timeout, FormSvc, QuestionnaireSvc, getData) {
  $scope.theRecord=getData.theRecord
  $scope.classes=getData.classes
  $scope.tags=getData.tags
  if ($scope.tags) {
    QuestionnaireSvc.reset($scope,{tagTarget:'tags'})  // Ensure in pristine state
    $timeout(function(){  // Must be done after fully loaded
      QuestionnaireSvc.linkFormFields($scope,{tagTarget:'tags'})
      $scope.$broadcast('isEditing',true)
      },0,true,true)
    }
  $scope.myScope=$scope
  $scope.formError=''
  $scope.isEditing=true
  $scope.save=function () {
    if ($scope.theForm.$valid) {
      if($scope.tags){$scope.theRecord.qanswers=QuestionnaireSvc.answers($scope,{tagTarget:'tags'})}
      $scope.$close($scope.theRecord)
    } else {
      FormSvc.alert("Error", "There are invalid values", "error")
      FormSvc.setSubmitted($scope,true)
    }
  }
})

.controller('ModalInfoCtrl', function ($scope, getData) {
  $scope.data=getData
  $scope.myScope=$scope
})

